module.exports = __webpack_public_path__ + "img/BG.5d8f55f0.png";